<p>notification-snack-bar works!</p>
